import { render } from "./BotoesEdicao.vue?vue&type=template&id=121d1f60&scoped=true&ts=true"
import script from "./BotoesEdicao.vue?vue&type=script&lang=ts"
export * from "./BotoesEdicao.vue?vue&type=script&lang=ts"

import "./BotoesEdicao.vue?vue&type=style&index=0&id=121d1f60&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-121d1f60"]])

export default __exports__